import React, {Fragment} from 'react';
import {calculateTripDuration} from "@Route/functions/calculateTripDuration";
import Column from "@Containers/components/Column";
import StationWithDateTimesType from "@SearchResults/types/station/StationWithDateTimes.type";
import TransportTypeChangeLabel from "@Route/components/Connection/TransportTypeChangeLabel";
import RouteBusLayoverDuration from "@Route/components/Connection/ExpandedRoute/RouteBusLayoverDuration";
import Row from "@Containers/components/Row";
import RouteBusChangeDetails from "@Route/components/Connection/ExpandedRoute/RouteBusChangeDetails";

interface RouteBusLayoverProps {
    stop: StationWithDateTimesType,
    departureDate: string,
    departureTime: string,
    arrivalDate: string,
    arrivalTime: string,
    numberOfChanges: number,
    companyLetterCode: string,
    index: number
}

function RouteBusLayover({
                             stop,
                             departureDate,
                             departureTime,
                             arrivalDate,
                             arrivalTime,
                             numberOfChanges,
                             companyLetterCode,
                             index,
                         }: RouteBusLayoverProps) {
    const {
        arrivalDate: stopArrivalDate,
        arrivalTime: stopArrivalTime,
        departureDate: stopDepartureDate,
        departureTime: stopDepartureTime,
        id,
    } = stop

    const tripDurationBeforeLayover = calculateTripDuration(
        `${departureDate} ${departureTime}`,
        `${stopArrivalDate} ${stopArrivalTime}`
    )
    const calculatedLayover = calculateTripDuration(
        `${stopArrivalDate} ${stopArrivalTime}`,
        `${stopDepartureDate} ${stopDepartureTime}`
    )

    const tripDurationAfterLayover = calculateTripDuration(
        `${stopDepartureDate} ${stopDepartureTime}`,
        `${arrivalDate} ${arrivalTime}`
    )

    return (
        <Fragment key={id}>
            {index === 0 && (
                <RouteBusLayoverDuration
                    tripDuration={tripDurationBeforeLayover}
                    companyLetterCode={companyLetterCode}
                />
            )}
            <Row>
                <Column className="route-travel-details--first-column-large route-travel-details--layover">
                        <span className="gb--emphasize-default">
                            <TransportTypeChangeLabel
                                numberOfChanges={numberOfChanges}
                            />
                        </span>
                    <small>
                        {`${calculatedLayover} layover`}
                    </small>
                </Column>
                <div className="gb--connect-divider_vertical">
                    <span className="gb--connect-circle gb--connect-circle--blue"/>
                </div>
                <RouteBusChangeDetails stop={stop}/>
            </Row>
            <RouteBusLayoverDuration
                tripDuration={tripDurationAfterLayover}
                companyLetterCode={companyLetterCode}
            />
        </Fragment>
    );
}

export default RouteBusLayover;